module.exports = __webpack_public_path__ + "assets/transportation_white.0cae9b2f.svg";